export default "__VITE_ASSET__CeNkAXg9__"